var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-state",class:_vm.size,attrs:{"role":"status","aria-label":_vm.label}},[_c('span',{staticClass:"loading-spinner",attrs:{"aria-hidden":"true"}}),(_vm.message)?_c('span',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }